"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactScroll = require("react-scroll");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _sectionNav = _interopRequireDefault(require("./section-nav.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var previousScrollY = 0;
var getScrollPosition = function getScrollPosition() {
  return typeof window !== 'undefined' ? window.pageYOffset || document.documentElement.scrollTop : 0;
};
var getScrollDirection = function getScrollDirection(scrollPosition) {
  return scrollPosition > previousScrollY ? 'down' : 'up';
};
var SectionNav = function SectionNav(_ref) {
  var _clsx;
  var className = _ref.className,
    market = _ref.market,
    language = _ref.language,
    sections = _ref.sections;
  var _useState = (0, _react.useState)(false),
    attachToPrimaryNav = _useState[0],
    setAttachToPrimaryNav = _useState[1];
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
    }
  }, []);
  var handleScroll = function handleScroll() {
    var scrollPosition = getScrollPosition();
    var scrollDirection = getScrollDirection(scrollPosition);
    previousScrollY = scrollPosition;
    if (scrollDirection === 'up') {
      setAttachToPrimaryNav(true);
    } else {
      setAttachToPrimaryNav(false);
    }
  };
  var handleClick = function handleClick(event, target) {
    var element = event.target;
    element.scrollIntoView({
      inline: 'center',
      behavior: 'smooth',
      block: 'nearest'
    });
    if (market.toLowerCase() === 'us' && typeof window !== 'undefined' && window.dataLayer) {
      var _event$target;
      var pathnames = window.location.pathname.split('/');
      var nameplate = pathnames[pathnames.length - 1];
      window.dataLayer.push({
        event: 'clickevent',
        section_name: 'navigation',
        component: 'VLP Nav',
        action: 'VLP Nav Click',
        click_text: event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.text,
        nameplate: nameplate && nameplate.replaceAll('-', ' ')
      });
    }
  };
  var handleSetActive = function handleSetActive(to) {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      var listItems = document.querySelectorAll("ul#section-links li a");
      var activeItem = document.querySelectorAll("ul#section-links li a[class*='isActive']");
      listItems.values().forEach(function (item, index) {
        if (item === activeItem[0]) {
          item.scrollIntoView({
            inline: 'center',
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  };
  var renderLink = function renderLink(section, idx) {
    return /*#__PURE__*/_react["default"].createElement(_reactScroll.Link, {
      onClick: function onClick(event) {
        return handleClick(event, section.id, idx);
      },
      to: section.id,
      key: idx,
      activeClass: "" + _sectionNav["default"].isActive,
      spy: true,
      smooth: true,
      duration: 500,
      onSetActive: handleSetActive
    }, section.label);
  };
  var renderSectionNavLinks = function renderSectionNavLinks(sections) {
    var links;
    if (sections && sections.length > 0) {
      links = sections.map(function (section, idx) {
        return /*#__PURE__*/_react["default"].createElement("li", null, renderLink(section, idx));
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, links);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(_sectionNav["default"].sectionNav, _sectionNav["default"].isHidden, className, (_clsx = {}, _clsx[_sectionNav["default"].attachToPrimaryNav] = attachToPrimaryNav, _clsx))
  }, sections && sections.length > 0 && /*#__PURE__*/_react["default"].createElement("ul", {
    id: "section-links"
  }, renderSectionNavLinks(sections))));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language,
    sections: state.sideNavData.sections
  };
};
SectionNav.resourceType = function () {
  return 'SectionNav_1_0_0';
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(SectionNav);
exports["default"] = _default;